import { useState, useEffect } from 'react'

interface Size {
    width: number
    height: number
    isDesktop: boolean
}
enum SizeConfig {
    desktop = 1200,
}
function useWindowSize(): Size {
    const [windowSize, setWindowSize] = useState<Size>({
        width: 0,
        height: 0,
        isDesktop: false,
    })
    useEffect(() => {
        const handleResize = () => {
            if (windowSize.width > SizeConfig.desktop) {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                    isDesktop: false,
                })
            } else {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                    isDesktop: true,
                })
            }
        }
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [windowSize.width])
    return windowSize
}
export default useWindowSize
